import React from 'react'

export default ({ width, height }) => (
  <svg
    width={width || '26'}
    height={height || '26'}
    viewBox="0 0 26 26"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g stroke="#454545" fill="none" fillRule="evenodd">
      <path d="M24.785 24.742h-4.928V17.03c0-1.84-.032-4.205-2.56-4.205-2.566 0-2.958 2.004-2.958 4.073v7.844H9.416V8.882h4.724v2.17h.07c.656-1.248 2.264-2.562 4.662-2.562 4.99 0 5.913 3.283 5.913 7.554v8.698zM3.86 6.717C2.277 6.717 1 5.437 1 3.857 1 2.28 2.277 1 3.86 1c1.576 0 2.856 1.28 2.856 2.858s-1.28 2.86-2.856 2.86zM1.39 24.742h4.935V8.882H1.39z" />
    </g>
  </svg>
)



// WEBPACK FOOTER //
// ./src/icons/linkedInIcon.js